export default __webpack_public_path__ + "static/media/NotoSans-Bold.23e70cfb.ttf";